import * as React from 'react';
import styled from 'styled-components';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { Container, Row, Col } from 'react-bootstrap';
import LinkComponent from '../../utils/linkComponent';

const FooterLinksStyled = styled.div`
	//margin-bottom: 2em;
	.footer {
		background: ${(props) => props.bgColor};
	}

	ul {
		padding-inline-start: 1px !important;
	}

	li {
		list-style: none !important;
		font-size: 1em;
	}

	h3 {
		margin-top: 1em;
		color: var(--primary);
		font-size: 1em;
	}
	a {
		color: var(--primary);
		text-decoration: none;
		font-size: 1em;
	}

	// Medium to large screens - allow wrapping similar to header menu (covers 1175px)
	@media (min-width: 768px) and (max-width: 1199.98px) {
		.row {
			flex-wrap: wrap !important;
		}

		.row > * {
			flex: 0 1 auto;
			min-width: fit-content;
		}

		li {
			white-space: normal;
			word-break: break-word;
		}
		h3 {
			white-space: normal;
			word-break: break-word;
		}
		a {
			white-space: normal;
			word-break: break-word;
		}
	}

	// Large screens and above (1200px+) - prevent wrapping
	@media (min-width: 1200px) {
		li {
			white-space: nowrap;
		}
		h3 {
			white-space: nowrap;
		}
		a {
			white-space: nowrap;
		}
	}

	// Small and extra small screens - allow wrapping
	@media (max-width: 767px) {
		li {
			white-space: normal;
		}
		h3 {
			white-space: normal;
		}
		a {
			white-space: normal;
		}
	}
`;

export default function FooterLinks(data) {
	const footerMenuData = useStaticQuery(graphql`
		query FooterMenuQuery {
			allStrapiNavigationPluginFooterMenu(sort: { order: ASC }) {
				nodes {
					items {
						path
						title
						type
					}
					order
					title
					type
					path
				}
			}
			allStrapiAsset {
				nodes {
					footer_background_colour
				}
			}
		}
	`);
	const backgroundColourRaw =
		footerMenuData.allStrapiAsset.nodes?.[0]?.footer_background_colour;
	const backgroundColour = backgroundColourRaw?.startsWith('--')
		? `var(${backgroundColourRaw})`
		: backgroundColourRaw?.startsWith('var(')
		? backgroundColourRaw
		: `var(--${backgroundColourRaw})`; // Wrap named token in var()

	//console.log('Background colour from Strapi:', backgroundColour);

	// Divide the FooterArray into 4 items length array
	var arr = footerMenuData.allStrapiNavigationPluginFooterMenu?.nodes;
	const chunk = 4;
	var footerItemArray = [];
	for (let i = 0; i < arr.length; i += chunk) {
		footerItemArray.push(arr.slice(i, i + chunk));
	}
	return (
		<FooterLinksStyled bgColor={backgroundColour}>
			<div className='footer'>
				<Container>
					{footerItemArray.map((footerChunk, index) => (
						<Row key={index} className='justify-content-center'>
							{footerChunk.map((menuItem) => (
								<Col xs={12} sm={6} md={4} lg={3} key={menuItem.title}>
									{
										(menuItem.path = '/' ? (
											<h3>{menuItem.title}</h3>
										) : (
											<LinkComponent
												to={menuItem.path}
												onClick={() => {
													window.analytics.track('Link Clicked', {
														page_name: data.props.title,
														title: menuItem?.title ? menuItem.title : null,
														static_component_title: 'Footer',
														link_name: menuItem?.title ? menuItem.title : null,
														link: menuItem?.path ? menuItem.path : null,
														path: window.location.pathname,
														item_title: menuItem?.title ? menuItem.title : null,
														report_type: 'New',
														url: window.location.href,
													});
												}}
											>
												<h3>{menuItem.title}</h3>
											</LinkComponent>
										))
									}
									<ul>
										{menuItem?.items?.map((item) => (
											<li key={item.title}>
												<LinkComponent
													to={item.path}
													onClick={() => {
														window.analytics.track('Link Clicked', {
															page_name: data.props.title,
															title: menuItem?.title ? menuItem.title : null,
															static_component_title: 'Footer',
															link_name: item?.title ? item.title : null,
															link: item?.path ? item.path : null,
															path: window.location.pathname,
															item_title: item?.title ? item.title : null,
															report_type: 'New',
															url: window.location.href,
														});
													}}
												>
													{item.title}
												</LinkComponent>
											</li>
										))}
									</ul>
								</Col>
							))}
						</Row>
					))}
				</Container>
			</div>
		</FooterLinksStyled>
	);
}
